import React from "react";
import styled from "styled-components";

interface IInfoIconProps {
  onClick: () => void;
}

const StyledInfoIcon = styled.i`
  cursor: pointer;
  color: var(--primary-500, #3b82f6);
  font-size: 1rem;
  margin-left: 0.5rem;
  transition: color 0.2s ease;

  &:hover {
    color: var(--primary-700, #1d4ed8);
  }
`;

/**
 * InfoIcon component - Displays a clickable info icon
 * @param onClick - Callback function when icon is clicked
 */
export function InfoIcon({ onClick }: IInfoIconProps) {
  return (
    <StyledInfoIcon
      className="pi pi-info-circle"
      onClick={onClick}
      role="button"
      aria-label="View precalculated allowables details"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick();
        }
      }}
    />
  );
}
